import { render, staticRenderFns } from "./CardContentPages.vue?vue&type=template&id=461b96c5&scoped=true&"
import script from "./CardContentPages.vue?vue&type=script&lang=js&"
export * from "./CardContentPages.vue?vue&type=script&lang=js&"
import style0 from "./CardContentPages.vue?vue&type=style&index=0&id=461b96c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461b96c5",
  null
  
)

export default component.exports